"use client"

import { getLangCode } from "@/src/utils/string/getLangCode"
import { t } from "@/translations"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { v4 as uuidv4 } from "uuid"

type TypeFormProps = {
    data?: {
        _type: "typeFormBlock"
        typeFormId?: {
            en?: string
            de?: string
            fr?: string
            ja?: string
        }
    }
}

export default function TypeForm({ data }: TypeFormProps) {
    const [iframeHeight, setIframeHeight] = useState<number | null>(null)
    // Eftersom man kan använda samma formulär på flera ställe behöver man skapa uniq id för iframen(kanske finns bättre sätt)
    const [iframeId] = useState(uuidv4())
    const langCode = getLangCode(usePathname().split("/")[1]) ?? "en"

    const typeFormBaseUrl = process.env.NEXT_PUBLIC_TYPEFORM_BASE_URL || ""
    const typeFormUrl = process.env.NEXT_PUBLIC_TYPEFORM_BASE_FORMS_URL || ""

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.origin !== typeFormBaseUrl) return

            const { height } = event.data

            // Set den högsta höjden som komemr in för att slippa layer shift när formulären flippar
            if (
                height &&
                typeof height === "number" &&
                (iframeHeight === null || height > iframeHeight)
            ) {
                setIframeHeight(height)
            }
        }

        window.addEventListener("message", handleMessage)

        return () => {
            window.removeEventListener("message", handleMessage)
        }
    }, [iframeHeight, typeFormBaseUrl])

    return (
        <div
            className="py-32 md:py-56"
            style={{
                width: "100%",
                height: iframeHeight ? `${iframeHeight}px` : "auto"
            }}
        >
            {data?.typeFormId?.en && (
                <iframe
                    src={`${typeFormUrl}/${data.typeFormId.en}`}
                    className="w-full sm:w-1/3"
                    id={iframeId}
                    title={t(langCode, "common.form")}
                    style={{
                        height: `${iframeHeight ? iframeHeight : 0}px`,
                        border: "none"
                    }}
                />
            )}
        </div>
    )
}
